import { useSessionStore } from '../store/sessionStore';
import './CurrentTrack.css';

/** Полноэкранный оверлей текущего трека на ТВ. */
export const CurrentTrack = () => {
  const { currentTrack, showInfo, isPlaying } = useSessionStore((state) => state.session);

  if (!currentTrack || !isPlaying) {
    return null;
  }

  return (
    <div className="current-track-fullscreen">
      {showInfo ? (
        <div className="current-track-content">
          <div className="current-track-info">
            <div className="current-track-artist">{currentTrack.artist}</div>
            <div className="current-track-title">{currentTrack.title}</div>
          </div>
        </div>
      ) : (
        <div className="current-track-waiting">Играет отрывок</div>
      )}
    </div>
  );
};
